// src/components/esg/CountrySpecificComplianceSelector.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import CountryButton from "../buttonsComponent/CountryButton"; // new non-routing button
import NavigationButtons from "helper/navigation/NavigationButtons";

const CountrySpecificComplianceSelector = ({
  onCountrySelect,
  activeStep = 0,
}) => {
  return (
    <>
      <Box
        sx={{
          borderRadius: "8px",
          padding: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            maxWidth: "600px",
          }}
        >
          {[
            { title: "Singapore", value: "singapore" },
            { title: "Malaysia", value: "malaysia" },
            { title: "Indonesia", value: "indonesia" },
            { title: "Vietnam", value: "vietnam" },
            { title: "Thailand", value: "thailand" },
            { title: "Philippines", value: "philippines" },
          ].map((country) => (
            <CountryButton
              key={country.value}
              title={country.title}
              isSpecial={country.isSpecial}
              onClick={() => onCountrySelect(country.value)}
            />
          ))}
        </Box>
      </Box>
    </>
  );
};

export default CountrySpecificComplianceSelector;
